import { Schema as Schema_ } from '@blade/std-lib'

import { DelugeId, DelugeIdSchema } from './DelugeId'

import type { ServicesApi } from '@root/shared/api'
import type { AvatarsHost } from '@root/shared/models'

export const Schema = Schema_.Struct({
  delugeId: DelugeIdSchema,
  username: Schema_.mutableKey(Schema_.String),
  avatarSrc: Schema_.mutableKey(
    Schema_.UndefinedOrFromOptional(Schema_.String),
  ),
})
export interface UserMinimal extends Schema_.Schema.Type<typeof Schema> {}

type Dto = NonNullable<ServicesApi.TradeTxDto['maker']['owner']>
export const fromDto = (dto: Dto, avatarsHost: AvatarsHost): UserMinimal => {
  return {
    delugeId: DelugeId(dto.delugeId),
    username: dto.username,
    avatarSrc: dto.avatar ? `${avatarsHost}/${dto.avatar}` : undefined,
  }
}
